var render = function () {
  var _vm$program, _vm$program$thumb, _vm$program2, _vm$program3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": (_vm$program = _vm.program) === null || _vm$program === void 0 ? void 0 : (_vm$program$thumb = _vm$program.thumb) === null || _vm$program$thumb === void 0 ? void 0 : _vm$program$thumb.url
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con py-20 pt-lg-20 pb-lg-30 px-lg-40"
  }, [_c('div', {
    staticClass: "mb-10 mb-md-14"
  }, [_c('h4', {
    staticClass: "tit tit--sm font-notoserif primary--text ellip"
  }, [_vm._v(_vm._s((_vm$program2 = _vm.program) === null || _vm$program2 === void 0 ? void 0 : _vm$program2.subject))])]), _c('div', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("일시")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-12"
  }, [_vm._v(_vm._s(_vm.at))])])], 1), _c('v-row', {
    staticClass: "mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("기간")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-12"
  }, [_vm._v(_vm._s(_vm.duration))])])], 1), _c('v-row', {
    staticClass: "mt-2 mt-md-4",
    attrs: {
      "no-gutters": "",
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("장소")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "grey-68--text pl-12"
  }, [_vm._v(_vm._s((_vm$program3 = _vm.program) === null || _vm$program3 === void 0 ? void 0 : _vm$program3.location))])])], 1)], 1)]), _c('v-divider', {
    staticClass: "primary"
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }